import React from "react";
import { withStyles } from "@material-ui/core";
import { Clear } from "@material-ui/icons";
import { ConsultantSelector_GetValueComponent } from "@graphql";
import { Classes, ThemeType } from "@theme";
import { Spinner } from "@components";
import { ConsultantCardContent } from "@consultants/ConsultantCard/ConsultantCardContent";
import { Value } from "../base/utils";

type Props = {
  clearable: boolean;
  classes: Classes<typeof styles>;
  disabled: boolean;
  onClear: (e: React.SyntheticEvent<any>) => void;
  value: Value[];
};

class ConsultantSelectorValue extends React.Component<Props> {
  render() {
    const { classes } = this.props;

    return (
      <>
        {this.props.value.map(({ value: id }) => (
          <ConsultantSelector_GetValueComponent key={id} variables={{ id }}>
            {({ data, error, loading }) => {
              if (error) {
                return <div>Error: {error.toString()}</div>;
              }

              if (loading) {
                return <Spinner />;
              }

              return (
                <div style={{ flex: 1 }}>
                  <ConsultantCardContent item={data.consultantById} style={{ flex: 1 }} />

                  {this.props.clearable && !this.props.disabled && (
                    <div className={classes.clear}>
                      <Clear onClick={this.props.onClear} fontSize="small" />
                    </div>
                  )}
                </div>
              );
            }}
          </ConsultantSelector_GetValueComponent>
        ))}
      </>
    );
  }
}

const styles = (theme: ThemeType) => ({
  clear: {
    alignItems: "center",
    display: "flex",
    paddingRight: 16,
    position: "absolute",
    right: 0,
    top: 0,
    bottom: 0,

    "& > svg": {
      opacity: 0.65,
      transition: theme.transitions.create("opacity", { duration: 100 })
    },

    "& > svg:hover": {
      opacity: 0.9,
      cursor: "pointer"
    }
  }
});

export default withStyles(styles as any)(ConsultantSelectorValue);
